import Navigation from './components/Navigation';
import Home from './pages/Home';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main className="App-main">
        <Home />
      </main>
      <footer className="footer">
        <p>&copy; 2026 PixelsParadox. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
